<ef-loading-container
    [observables]="[process$, IndirectRateHistoryModel$]"
></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<div class="card">
    <form [formGroup]="filterFormGroup" style="min-width: 14em">
        <p-toolbar styleClass="mb-1">
            <p-floatLabel variant="on">
                <p-calendar
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    yearRange="2010:2030"
                    appendTo="body"
                    [showIcon]="false"
                    id="startdate"
                    formControlName="startdate"
                >
                </p-calendar>
                <label for="float-dd">Start Date</label>
            </p-floatLabel>
            <p-floatLabel variant="on">
                <p-calendar
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    yearRange="2010:2030"
                    appendTo="body"
                    [showIcon]="false"
                    id="enddate"
                    formControlName="enddate"
                >
                </p-calendar>
                <label for="float-dd">End Date</label>
            </p-floatLabel>
        </p-toolbar>
    </form>
    <div class="rate-history">
        <ef-indirect-rate-history-presenter
            [items]="IndirectRateHistoryModel$ | async"
            [loading]="IndirectRateHistoryModelDS.loading$ | async"
            [cols]="cols"
            [colGroups]="colGroups"
            (RateChangeOnlyChanged)="RateChangeOnlySubject.next($event)"
        ></ef-indirect-rate-history-presenter>
    </div>

</div>
